import dayjs from 'dayjs';
import {
  EMPTY_TABLE_MESSAGES,
  LEAVE_PRIMARY_VIEWS,
  LEAVE_STATUS,
  LEAVE_STATUS_CATEGORIES,
} from '../constants';

/**
 * Returns leaves filtered by primary view and closed status.
 *
 * @param {Object} leavesByStatus
 * @param {'active' | 'closed'} view
 * @param {'approved' | 'rejected'} closedStatus
 * @returns {Array}
 */
export function getVisibleLeaves(leavesByStatus, view, closedStatus) {
  if (!leavesByStatus) return [];

  if (view === LEAVE_PRIMARY_VIEWS.ACTIVE) {
    return leavesByStatus.pending || [];
  }

  return leavesByStatus[closedStatus] || [];
}

/**
 * Returns the category of a leave based on its status.
 *
 * @param {'pending' | 'approved' | 'rejected'} status
 * @returns {'active' | 'closed' | null}
 */
export function getLeaveCategory(status) {
  return LEAVE_STATUS[status]?.category ?? null;
}

/**
 * Checks if a leave is considered active.
 *
 * @param {'pending' | 'approved' | 'rejected'} status
 * @returns {boolean}
 */
export function isActiveLeave(status) {
  return getLeaveCategory(status) === LEAVE_STATUS_CATEGORIES.ACTIVE;
}

/**
 * Returns the empty message for a given view and closed status.
 *
 * @param {'active' | 'closed'} view
 * @param {'approved' | 'rejected'} closedStatus
 * @returns {string}
 */
export function getEmptyMessage(view, closedStatus) {
  if (view === LEAVE_PRIMARY_VIEWS.ACTIVE) {
    return EMPTY_TABLE_MESSAGES[LEAVE_PRIMARY_VIEWS.ACTIVE];
  }
  return EMPTY_TABLE_MESSAGES[closedStatus] || 'No leaves found';
}

/**
 * Calculates the number of days between two dates.
 *
 * @param {string} startDate
 * @param {string} startSession
 * @param {string} endDate
 * @param {string} endSession
 * @returns {number}
 */
export function calculateLeaveDuration({ startDate, startSession, endDate, endSession }) {
  if (!startDate) return 0;

  const start = dayjs(startDate);
  const end = endDate ? dayjs(endDate) : start;

  let days = end.diff(start, 'day') + 1;

  if (startSession && startSession !== 'Full Day') days -= 0.5;
  if (endDate && endSession && endSession !== 'Full Day') days -= 0.5;

  return Math.max(days, 0);
}
